<template>
    <a
        class="dashboard__list_learner_grid_item"
        @click="handlePrimaryButtonRedirect(primaryButtonData.routeName, primaryButtonData.hash)"
    >
        <div class="columns">
            <div class="column is-narrow">
                <div class="dashboard__list_learner_grid_item_image">
                    <template v-if="sessionEventThumbnail">
                        <component-image
                            :url="sessionEventThumbnail"
                            :alt="sessionEventName"
                            :full-height="true"
                        ></component-image>
                    </template>
                    <template v-else>
                        <v-icon name="image"/>
                    </template>
                </div>
            </div>
            <div class="column">
                <div class="dashboard__list_learner_grid_item_content">
                    <h2 class="dashboard__list_learner_grid_item_content_title">{{ sessionEventName }}</h2>
                    <div class="dashboard__list_learner_grid_item_content_details">
                        <div class="dashboard__list_learner_grid_item_content_details_session">
                            <div class="columns is-vcentered is-variable is-2">
                                <div class="column is-narrow">
                                    <v-icon name="calendar"/>
                                </div>
                                <div class="column">
                                    {{ sessionDate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dashboard__list_learner_grid_item_content_status">
                        <component-status :status="sessionStatus"/>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import api from '@/api'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  name: 'dashboard-list-learner-grid-item',
  components: { ComponentImage, ComponentStatus },
  computed: {
    sessionId () {
      return this.item.occurrenceId
    },
    sessionEventName () {
      return this.item.name
    },
    sessionEventThumbnail () {
      if (this.item.images && this.item.images.length) {
        return `${api.files}/file/${this.item.images[0].imageId}`
      }
      return false
    },
    sessionEventId () {
      return this.item.eventId
    },
    sessionStatus () {
      return this.item.learnerStatus || this.item.bookingStatus
    },
    sessionSpaces () {
      const available = Number(this.item.maxBookingLimit)
      const bookings = Number(this.item.bookings)
      return `${available - bookings} / ${available}`
    },
    sessionVenueLocation () {
      let location = this.item.location
      let occurrenceItems = this.sessionOccurrenceItems
      let platform = occurrenceItems && occurrenceItems.length && occurrenceItems[0] ? occurrenceItems[0].platform : null

      return location || platform
    },
    sessionRoomLocation () {
      return this.item.roomLocation
    },
    sessionWorkspaceId () {
      return this.item.workspaceId
    },
    sessionTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.firstDate))
    },
    sessionDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.firstDate))
    },
    //
    currentWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    primaryButtonData () {
      let text
      let hash
      let routeName
      switch (this.sessionStatus) {
        default:
          text = 'View'
          routeName = 'ebs-session-show'
          break
      }
      return { text, hash, routeName }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    handleSwitchWorkspaceRedirect (to) {
      const currentWorkspaceId = this.currentWorkspaceId
      const sessionWorkspaceId = this.sessionWorkspaceId

      if (currentWorkspaceId !== sessionWorkspaceId) {
        this.$store.dispatch('authUserLoginSSOWorkspace', sessionWorkspaceId).then(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `Your workspace has been switched.`,
            status: 'success'
          })
          this.$router.push(to)
        }).catch(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `You can't be redirected to the session due to issues with switching workspace.`,
            status: 'error'
          })
        })
      } else {
        this.$router.push(to)
      }
    },
    handlePrimaryButtonRedirect (routeName, hash) {
      this.handleSwitchWorkspaceRedirect({ name: routeName, hash: hash, params: { sessionId: this.sessionId, eventId: this.sessionEventId } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/dashboardlistgriditem";
</style>
